<template>
<b-form-group id="fieldset1" :invalid-feedback="invalidFeedback" :valid-feedback="validFeedback" :state="state" description="Pris for produktet" label="Pris" label-for="price">
  <b-input-group size="sm" append="kr">
    <b-form-input id="price" :value="value" type="number" min="1" max="100000" step="1" class="form-control" @input="$emit('input', $event)" />
  </b-input-group>
</b-form-group>
</template>

<script>
export default {
  name: 'Price',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    state() {
      return this.value.length >= 1 ? true : false
    },
    invalidFeedback() {
      if (this.value.length > 0) {
        return ''
      } else if (this.value.length == 0) {
        return 'Angiv mindst et tal'
      } else {
        return 'Angiv et tal'
      }
    },
    validFeedback() {
      return this.state === true ? '' : ''
    }
  }
}
</script>

<style scoped>
</style>
